import { statusActions } from '../slices/state';
import { warningBarActions } from '../slices/WarningBar';

const actions = {
  ...warningBarActions,
  ...statusActions,
};

export { actions };
